exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-close[data-v-15311179]{background:linear-gradient(146.24deg,#114e67,#0a364d),radial-gradient(circle at 50% 50%,#59c8fc 0,rgba(82,172,229,0) 100%);border:1px solid #34b9f2;top:var(--containerSingleCloseTop);right:var(--containerSingleCloseRight)}", ""]);

// exports
